const pollSkeletonStyle = {
    skeleton: `min-h-[150px] max-h-[150px] rounded-[7px] animate-pulse w-full`
}

export { pollSkeletonStyle }